// export default [
//     'linear-gradient(81.93deg, #D04B6A 1.86%, #EE9565 100%)',
//     'linear-gradient(80deg, #854FB0 1.5%, #DF69B7 100%)',
//     'linear-gradient(81.67deg, #3A83B1 1.2%, #47B2E2 98.87%)',
//     'linear-gradient(81.92deg, #33AA9D 1.5%, #8EB683 99.5%)',
//     '#6ebbe8',
//     '#689e41',
//     '#bbbab8',
//     '#f3e7e5',
// ];

// // old colors
// export const labelColors = [
//     '#BE7A6F',
//     '#7A6FBE',
//     '#1193F0',
//     '#8EB683',
//     '#848382',
//     '#E5B711',
//     '#b73b7d',
// ];

export const getRandomColor = () => {
    var rgb = [];

    for (var i = 0; i < 3; i++) rgb.push(Math.floor(Math.random() * 255));

    return 'rgb(' + rgb.join(',') + ')';
};

const setColors = () => {
    const colors = [
        '#33B1A5', // teal
        '#6941C6', // purple
        '#FF6B35', // orange
        '#023F88', // navy blue
        '#FFD700', // gold
        '#FB2F79', // pink
        '#3FC045', // green
        '#8E44AD', // violet
        '#F39C12', // amber
        '#C0392B', // red

        '#1ABC9C', // turquoise
        '#3498DB', // sky blue
        '#9B59B6', // soft purple
        '#E67E22', // deep orange
        '#2ECC71', // light green
        '#E74C3C', // bright red
        '#34495E', // dark gray-blue
        '#7ecabbff', // dark teal
        '#D35400', // burnt orange
        '#2C3E50', // deep blue-gray
        'grey',
    ];

    for (let i = 0; i < 90; i++) {
        colors.push(getRandomColor());
    }

    return colors;
};

const setChartColors = () => {
    const colors = [
        { start: '#33B1A5', end: '#33B183' }, // teal
        { start: '#6941C6', end: '#6941C6' }, // purple
        { start: '#FF6B35', end: '#FF6B35' }, // orange
        { start: '#023F88', end: '#023F88' }, // navy blue
        { start: '#FFD700', end: '#FFD700' }, // gold
        { start: '#FB2F79', end: '#FB2F79' }, // pink
        { start: '#3FC045', end: '#3FC045' }, // green
        { start: '#8E44AD', end: '#8E44AD' }, // violet
        { start: '#F39C12', end: '#F39C12' }, // amber
        { start: '#C0392B', end: '#C0392B' }, // red
        { start: '#1ABC9C', end: '#1ABC9C' }, // turquoise
        { start: '#3498DB', end: '#3498DB' }, // sky blue
        { start: '#9B59B6', end: '#9B59B6' }, // soft purple
        { start: '#E67E22', end: '#E67E22' }, // deep orange
        { start: '#2ECC71', end: '#2ECC71' }, // light green
        { start: '#E74C3C', end: '#E74C3C' }, // bright red
        { start: '#34495E', end: '#34495E' }, // dark gray-blue
        { start: '#7ecabbff', end: '#7ecabbff' }, // dark teal
        { start: '#D35400', end: '#D35400' }, // burnt orange
        { start: '#2C3E50', end: '#2C3E50' }, // deep blue-gray
        { start: 'grey', end: 'grey' },
    ];

    for (let i = 0; i < 90; i++) {
        colors.push(getRandomColor());
    }

    return colors;
};

export const colors = setColors();
export const chartColors = setChartColors();

export const commerceColor = ['#D3D3D3', '#DCDCDC', '#C0C0C0', '#808080', '#696969', '#2F4F4F'];
